import { Injector, NgModule, ViewContainerRef } from '@angular/core';
import { WrapperModule } from '../../wrapper.module';

@NgModule({
  imports: [],
})
export class TaxonomyWrapperModule extends WrapperModule {

  public static getTaxonomyModuleLoader(): () => Promise<any> {
    return () =>
      import('taxonomy-extension/module');
  }

  public static async getTaxonomyDataListsService(...args: any[]): Promise<any> {
    return this.getService(this.getTaxonomyModuleLoader(), "TaxonomyDataListsService", ["AldenService", "SMTDataListsService"], ...args);
  }

  public static async getTaxonomyComponentInstance(componentName: string, containerRef: ViewContainerRef, injector?: Injector): Promise<any> {
    return super.getComponentInstance(this.getTaxonomyModuleLoader(), componentName, containerRef, injector);
  }

}
